import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LicenceState {
  readOnly: boolean;
  state: string | null;
}

export const NOT_READ_ONLY: LicenceState = {
  readOnly: false,
  state: null,
};

const licenceSlice = createSlice({
  name: "licence",
  initialState: NOT_READ_ONLY,
  reducers: {
    setLicenceStatus: (state, action: PayloadAction<LicenceState>) => {
      const next = action.payload;
      if (state.readOnly === next.readOnly && state.state === next.state) {
        return;
      }
      return next;
    },
  },
});

export const { setLicenceStatus } = licenceSlice.actions;

export default licenceSlice.reducer;
